(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enfami-collection-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.enfami-carousel').forEach(function(section) {
    var track = section.querySelector('[data-track]');
    var prev = section.querySelector('.enfami-carousel__arrow--prev');
    var next = section.querySelector('.enfami-carousel__arrow--next');
    if (!track) return;
    var step = function(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.75, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function() { step(-1); });
    if (next) next.addEventListener('click', function() { step(1); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enfami-promo-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-epb-countdown]').forEach(function(cd) {
    function pad(n) { return String(n).padStart(2, '0'); }
    var key = 'epb_cd_start';
    var start;
    try {
      start = parseInt(localStorage.getItem(key), 10);
      if (!start || Date.now() - start > 43200000) {
        start = Date.now();
        localStorage.setItem(key, String(start));
      }
    } catch (e) {
      start = Date.now();
    }
    function tick() {
      var elapsed = Date.now() - start;
      var diff = Math.max(0, 43200000 - elapsed);
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var hEl = cd.querySelector('[data-epb-h]');
      var mEl = cd.querySelector('[data-epb-m]');
      var sEl = cd.querySelector('[data-epb-s]');
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enfami-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.efUgcReady === '1') return;
    if (root.dataset.designMode === 'true') return;
    root.dataset.efUgcReady = '1';

    var viewport = root.querySelector('[data-ef-ugc-viewport]');
    var lb = root.querySelector('[data-ef-ugc-lb]');
    var lbGrid = root.querySelector('[data-ef-ugc-lb-grid]');
    var viewer = root.querySelector('[data-ef-ugc-viewer]');
    var fullImg = root.querySelector('[data-ef-ugc-full]');
    var vName = root.querySelector('[data-ef-ugc-vname]');
    var vLoc = root.querySelector('[data-ef-ugc-vloc]');
    var vCap = root.querySelector('[data-ef-ugc-vcap]');
    var vLink = root.querySelector('[data-ef-ugc-vlink]');
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true' && !prefersReduced;
    var items = [];
    var index = 0;
    var paused = false;

    function collectItems() {
      items = Array.prototype.map.call(root.querySelectorAll('[data-ef-ugc-item]'), function (el) {
        return {
          src: el.getAttribute('data-src'),
          thumb: el.getAttribute('data-thumb') || el.getAttribute('data-src'),
          name: el.getAttribute('data-name') || '',
          loc: el.getAttribute('data-loc') || '',
          cap: el.getAttribute('data-cap') || '',
          href: el.getAttribute('data-href') || '',
          product: el.getAttribute('data-product') || ''
        };
      }).filter(function (it) { return !!it.src; });
    }

    function pauseAuto() { paused = true; }
    function resumeAuto() { paused = false; }

    var inView = true;
    var rafId = null;
    function tick() {
      rafId = null;
      if (autoplay && viewport && !paused && inView && !document.hidden) {
        viewport.scrollLeft += 0.55;
        if (viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2) {
          viewport.scrollLeft = 0;
        }
      }
      if (autoplay) rafId = requestAnimationFrame(tick);
    }
    function startTick() {
      if (!autoplay || !viewport || rafId) return;
      rafId = requestAnimationFrame(tick);
    }
    function stopTick() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }
    if (autoplay && viewport) {
      startTick();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            inView = !!(entries[0] && entries[0].isIntersecting);
            if (inView) startTick();
            else stopTick();
          },
          { root: null, threshold: 0.05 }
        );
        io.observe(root);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopTick();
        else if (inView) startTick();
      });
    }

    function scrollByDir(dir) {
      if (!viewport) return;
      pauseAuto();
      viewport.scrollBy({ left: dir * Math.min(340, viewport.clientWidth * 0.75), behavior: 'smooth' });
      clearTimeout(root._efUgcResume);
      root._efUgcResume = setTimeout(resumeAuto, 2800);
    }

    if (viewport) {
      var down = false, startX = 0, startLeft = 0;
      viewport.addEventListener('pointerdown', function (e) {
        if (e.button && e.button !== 0) return;
        down = true;
        startX = e.clientX;
        startLeft = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        pauseAuto();
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      });
      viewport.addEventListener('pointermove', function (e) {
        if (!down) return;
        viewport.scrollLeft = startLeft - (e.clientX - startX);
      });
      function endDrag() {
        if (!down) return;
        down = false;
        viewport.classList.remove('is-dragging');
        setTimeout(resumeAuto, 2000);
      }
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('mouseenter', pauseAuto);
      viewport.addEventListener('mouseleave', resumeAuto);
    }

    var prev = root.querySelector('[data-ef-ugc-prev]');
    var next = root.querySelector('[data-ef-ugc-next]');
    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });

    function buildGrid() {
      if (!lbGrid) return;
      lbGrid.innerHTML = '';
      if (!items.length) {
        lbGrid.innerHTML = '<div class="ef-ugc-lb__empty">Aucune photo pour le moment.</div>';
        return;
      }
      items.forEach(function (it, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ef-ugc-lb__thumb';
        btn.innerHTML = '<img src="' + it.thumb + '" alt="' + (it.name || 'Photo') + '" loading="lazy">';
        btn.addEventListener('click', function () { openViewer(i); });
        lbGrid.appendChild(btn);
      });
    }

    function openLb() {
      collectItems();
      if (!items.length || !lb) return;
      buildGrid();
      if (viewer) viewer.hidden = true;
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      pauseAuto();
    }

    function closeLb() {
      if (lb) lb.hidden = true;
      if (viewer) viewer.hidden = true;
      document.documentElement.style.overflow = '';
      resumeAuto();
    }

    function openViewer(i) {
      if (!items.length || !fullImg) return;
      index = (i + items.length) % items.length;
      var it = items[index];
      if (!it || !it.src) return;
      if (viewer) viewer.hidden = false;
      fullImg.src = it.src;
      fullImg.alt = it.name || 'Photo';
      if (vName) vName.textContent = it.name || '';
      if (vLoc) vLoc.textContent = it.loc || '';
      if (vCap) vCap.textContent = it.cap || '';
      if (vLink) {
        if (it.href) {
          vLink.hidden = false;
          vLink.href = it.href;
          vLink.textContent = it.product ? ('Voir — ' + it.product) : 'Voir le produit';
        } else {
          vLink.hidden = true;
        }
      }
    }

    root.querySelectorAll('[data-ef-ugc-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('[data-ef-ugc-item]');
        collectItems();
        if (!items.length) return;
        var src = card && card.getAttribute('data-src');
        var i = items.findIndex(function (it) { return it.src === src; });
        openLb();
        if (i >= 0) openViewer(i);
      });
    });

    var allBtn = root.querySelector('[data-ef-ugc-all]');
    if (allBtn) allBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openLb();
    });

    root.querySelectorAll('[data-ef-ugc-close]').forEach(function (el) {
      el.addEventListener('click', closeLb);
    });

    var vBack = root.querySelector('[data-ef-ugc-vback]');
    if (vBack) vBack.addEventListener('click', function () {
      if (viewer) viewer.hidden = true;
    });
    var vPrev = root.querySelector('[data-ef-ugc-vprev]');
    var vNext = root.querySelector('[data-ef-ugc-vnext]');
    if (vPrev) vPrev.addEventListener('click', function () { openViewer(index - 1); });
    if (vNext) vNext.addEventListener('click', function () { openViewer(index + 1); });

    document.addEventListener('keydown', function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      if (viewer && !viewer.hidden) {
        if (e.key === 'ArrowLeft') openViewer(index - 1);
        if (e.key === 'ArrowRight') openViewer(index + 1);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-ef-ugc]').forEach(function (root) {
      delete root.dataset.efUgcReady;
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
